import { useEffect, useState } from "react";
import { TableData } from "@/App/ReconciliationFinancialTransactionsView/Table";
import { getShowFinancialReconciliationTransaction } from "@/Api/reconcialiationFinancialTransactions";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";

import { CircleDollarSign, ArrowLeft } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AddReconciliationFileBtn } from "@/App/ReconciliationFinancialTransactionsView/Add";
import { FiltersView } from "@/App/ReconciliationFinancialTransactionsView/Filters";
import { JobsPanel } from "@/App/ReconciliationFinancialTransactionsView/JobsPanel";

interface PaginationMeta {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export const PageView = () => {
  const [reconciliation, setReconciliation] = useState<any>({});
  const [state, setState] = useState("loading");
  const [filters, setFilters] = useState<Record<string, any>>({ payment_form_ids: "2", per_page: "100" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState<PaginationMeta | null>(null);
  const { uuid } = useParams();
  const navigate = useNavigate();

  const fetchData = async (page: number = 1, currentFilters = filters) => {
    setState("loading");
    try {
      const params: Record<string, string> = {
        ...currentFilters,
        page: page.toString(),
        per_page: currentFilters.per_page || "100",
      };

      const { data } = await getShowFinancialReconciliationTransaction(
        uuid || "",
        params
      );

      setReconciliation(data?.response);
      setPagination(data?.response?.pagination || null);
      setCurrentPage(page);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setState("production");
    }
  };

  const handleFilter = async (filterData: any) => {
    const payload: Record<string, any> = {
      start_date: filterData?.start_date || "",
      end_date: filterData?.end_date || "",
      financial_transaction_type_id:
        filterData?.financial_transaction_type_id || "",
      reconciliation_status_id: filterData?.reconciliation_status_id || "",
      per_page: filterData?.per_page || "100",
    };

    if (filterData?.payment_form_ids && filterData.payment_form_ids.length > 0) {
      payload.payment_form_ids = filterData.payment_form_ids.join(",");
    }

    setFilters(payload);
    await fetchData(1, payload);
  };

  const handlePageChange = (page: number) => {
    fetchData(page, filters);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Main>
      <div className="flex justify-center md:justify-between items-center flex-wrap gap-2 mb-4">
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            size="icon"
            onClick={() => navigate("/reconciliacao-financeira")}
            title="Voltar para listagem"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h2 className="text-2xl font-semibold flex gap-2 items-center">
            <CircleDollarSign className="h-6 w-6" />
            Conciliação Financeira
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <AddReconciliationFileBtn
            id={reconciliation?.id?.toString() || ""}
            itsPaidPayabled={reconciliation?.financial_type_id == 2}
            updateList={fetchData}
          />
        </div>
      </div>

      <FiltersView onFilter={handleFilter} noFormName />

      {reconciliation?.id && (
        <JobsPanel
          processId={reconciliation.id}
          onJobsComplete={fetchData}
        />
      )}

      {state === "loading" ? (
        <CreateLoaderTable cols={6} lines={6} />
      ) : (
        <TableData
          dataApi={reconciliation}
          refetch={() => fetchData(currentPage, filters)}
          pagination={pagination}
          onPageChange={handlePageChange}
          filters={filters}
        />
      )}
    </Main>
  );
};
